import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private readonly _counter = new BehaviorSubject<number>(0);
  private readonly _isLoading = new BehaviorSubject<boolean>(false);

  /**
   * Emits true when there is at least one in-flight HTTP request, false otherwise.
   */
  readonly isLoading$: Observable<boolean> = this._isLoading.asObservable();

  /**
   * Increments the in-flight request counter and emits loading state.
   */
  increment(): void {
    const next = this._counter.value + 1;
    this._counter.next(next);
    if (next === 1) {
      this._isLoading.next(true);
    }
  }

  /**
   * Decrements the in-flight request counter and emits loading state.
   * Does not decrement below zero.
   */
  decrement(): void {
    const next = Math.max(this._counter.value - 1, 0);
    this._counter.next(next);
    if (next === 0) {
      this._isLoading.next(false);
    }
  }
}